import { Button } from '@usealloy/component-library';
import styled, { css } from 'styled-components';

export const StyledAssistanceActions = styled.div<{
  inIsland: boolean;
}>`
  display: flex;
  align-items: center;
  gap: var(--cl-space-4);

  ${({ inIsland }) => (inIsland && css`
    justify-content: flex-end;
  `)}
`;

export const StyledToolbarButton = styled(Button)`
  &&& {
    height: auto;

    &:hover:not(:disabled) {
      background: transparent;
      backdrop-filter: brightness(0.9);
    }
  }
`;
